export enum UserSiteTypes {
  OptimaAdmin = 'OptimaAdmin',
  Korkortsboken = 'Korkortsboken',
}